module.exports = __webpack_public_path__ + "img/eq-magefist.f95c1563.png";